import $axios from '~/plugins/axios';

import { Api, PromoCategory, PromoCategoryRequest } from '~/api';
import { buildModule } from '../utils';
import { Dict, removeKey } from '~/helpers';

const api = $axios as Api;


export default buildModule()
	.withState({
		storedPromoCategories: {} as Dict<PromoCategory>,
	})
	.withGetters({
		byUuid: state => (promoUuid: string) => (
			state.storedPromoCategories[promoUuid] ?? null
		),
	})
	.withMutations({
		STORE_PROMO (state, category: PromoCategory) {
			state.storedPromoCategories = {
				...state.storedPromoCategories,
				[category.uuid]: category,
			};
		},
		REMOVE_STORED_PROMO_CATEGORY (state, uuid: string) {
			state.storedPromoCategories = removeKey(state.storedPromoCategories, uuid);
		},
	})
	.withActions({
		async post ({ commit }, request: PromoCategoryRequest) {
			const { data } = await api.post('/promo-category', request);
			commit('STORE_PROMO', data.payload);
		},
		async put ({ commit }, request: PromoCategoryRequest) {
			const { data } = await api.put(`/promo-category/${ request.uuid }`, request);
			commit('STORE_PROMO', data.payload);
		},
		async delete ({ commit }, uuid: string) {
			const { data } = await api.delete(`/promo-category/${ uuid }`);
			if (data.status === 'ok') { commit('REMOVE_STORED_PROMO_CATEGORY', uuid); }
		},
	});
